import React from 'react'
import CatCountCSS from './cat-count.module.css'

const CatCount = ({ children, catname, count }) => (
  <div className={`${CatCountCSS.number} catpagename`}>{count}</div>
)

export default CatCount
